import React from "react";
import { isNil } from "lodash";
import { polylineStyle } from "./styles";

const SolarBattery = ({ type = "up" }) => {
  if (isNil(type)) return null;
  return (
    <svg
      height="120px"
      width="120px"
      viewBox="-10 -10 120 120"
      style={{ position: "absolute", left: "60px", top: "-70px" }}>
      <defs>
        <marker
          id="startPointerSB"
          markerWidth="8"
          markerHeight="10"
          refX="8"
          refY="5"
          orient="-90"
          markerUnits="userSpaceOnUse"
          style={polylineStyle}>
          <polyline points="0 0, 8 5, 0 10" />
        </marker>
        <marker
          id="endPointerSB"
          markerWidth="8"
          markerHeight="10"
          refX="8"
          refY="5"
          orient="180"
          markerUnits="userSpaceOnUse"
          style={polylineStyle}>
          <polyline points="0 0, 8 5, 0 10" />
        </marker>
      </defs>
      <path
        d="M100 10 L 100 90 C 100 95 95 100 90 100 L 0 100"
        stroke="#004057"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
        markerEnd={type === "down" ? "url(#endPointerSB)" : ""}
        markerStart={type === "up" ? "url(#startPointerSB)" : ""}
      />

      <circle r="4" fill="#004057">
        <animateMotion
          dur="3s"
          repeatCount="indefinite"
          path={
            type === "up"
              ? "M0 100 L 90 100 C 95 100 100 95 100 90 L 100 10"
              : "M100 10 L 100 90 C 100 95 95 100 90 100 L 0 100"
          }
        />
      </circle>
    </svg>
  );
};
export default SolarBattery;
